var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-page"},[_c('Header'),_c('Banner'),_c('div',{staticClass:"m-pc-page page-bottom"},[_c('List')],1),(_vm.extraItem.extras('copyright.display'))?_c('div',{staticClass:"m-copyright",style:({
      textAlign: _vm.extraItem.extras('copyright.position'),
      color: _vm.extraItem.extras('copyright.color'),
      fontSize:
        _vm.extraItem.extras('copyright.fontSize') === 'big'
          ? '16px'
          : _vm.extraItem.extras('copyright.fontSize') === 'small'
          ? '12px'
          : '14px',
      fontWeight:
        _vm.extraItem.extras('copyright.bold') === 'bold' ? 'bold' : 'normal',
      fontStyle:
        _vm.extraItem.extras('copyright.italic') === 'italic'
          ? 'italic'
          : 'normal',
      whiteSpace: 'pre-line',
      paddingBottom: '30px'
    })},[_vm._v(" "+_vm._s(_vm.extraItem.extras("copyright.model"))+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }